export enum FinancialStatementImportDefinition {
    sheetName = 'sheetName',
    accountsStartingRow = 'accountsStartingRow',
    accountNo = 'accountNoCol',
    accountName = 'accountNameCol',
    balance = 'balanceColNo',
    previousYear = 'previousYearColNo',
    shareholder = 'shareholderColNo',
}
